import React from "react";

const TextBlock = () => {
  // Вычисляем количество лет работы сети (открытие 21 декабря 2011)
  const openDate = new Date(2011, 11, 21, 18, 0, 0);
  const now = new Date();
  const deltaYear = Math.floor((now - openDate) / (1000 * 60 * 60 * 24 * 365));

  return (
    <div className="text-block">
      <h2>
        <strong>Пояснения к финансовой модели</strong>
      </h2>
      <p>
        <strong>Основа расчетов:</strong> модель построена на статистических
        данных сети AGYM (14 клубов в 4 городах:
        <a
          href="https://agym69.ru/"
          className="anchor-link"
          target="_blank"
          rel="noopener noreferrer nofollow"
        >
          <strong>Тверь</strong>
        </a>
        ,
        <a
          href="https://ag72.ru/"
          className="anchor-link"
          target="_blank"
          rel="noopener noreferrer nofollow"
        >
          <strong>Тюмень</strong>
        </a>
        ,
        <a
          href="https://agym63.ru/"
          className="anchor-link"
          target="_blank"
          rel="noopener noreferrer nofollow"
        >
          <strong>Самара</strong>
        </a>
        ,
        <a
          href="https://agym77.ru/"
          className="anchor-link"
          target="_blank"
          rel="noopener noreferrer nofollow"
        >
          <strong>Клин</strong>
        </a>
        . Площадь клубов: 1100–2500 м²). Опыт работы сети на рынке — более{" "}
        <span id="agOpen">{deltaYear}</span> лет. Расчетный период модели — 7
        лет. <br />
        Показатели основаны на данных внутреннего управленческого учета сети
        AGYM. Управленческий учет ведется для целей операционного анализа и
        может отличаться от данных официальной бухгалтерской отчетности,
        представляемой в государственные органы. Данные усреднены и приведены
        для справки.
      </p>

      <h3>
        <a href="#inputData" className="anchor-link-title">
          <strong>Исходные данные для расчета:</strong>
        </a>
      </h3>
      <ul>
        <li>
          <strong>1. Площадь помещения</strong> (м²)
        </li>
        <li>
          <strong>2. Арендная ставка</strong> (руб/м² в месяц). Варианты:
          <ul>
            <li>- 0 руб/м² — если помещение в собственности</li>
            <li>- фактическая ставка — если помещение в аренде</li>
          </ul>
        </li>
        <li>
          <strong>3. Параметры кредита:</strong>
          <ul>
            <li>- Сумма кредита (руб)</li>
            <li>- Срок кредита (месяцев)</li>
            <li>- Процентная ставка (%)</li>
          </ul>
        </li>
      </ul>

      <h3>
        <a href="#outData" className="anchor-link-title">
          <strong>Рассчитываемые показатели:</strong>
        </a>
      </h3>
      <p>
        <strong>1. Сумма вложений</strong>
        <br />
        Общий объем капитальных вложений: от подготовки помещения до открытия
        клуба.
      </p>
      <p>
        <strong>2. Предполагаемая эффективность вложений</strong>
        <br />
        Эффективность вложений с учетом методологии NOPAT. Среднее значение за 7
        лет.
      </p>
      <p>
        <strong>3. Собственные средства</strong>
        <br />
        Разность между суммой вложений и привлекаемым кредитом. Показывает объем
        необходимых собственных средств.
      </p>

      <h3>
        <strong>Таблицы:</strong>
      </h3>
      <p>
        <a href="#ProfitAndLoss" className="anchor-link">
          <strong>
            1. Прогноз финансовых результатов и анализ эффективности
          </strong>
        </a>
        <br />
        Прогноз динамики доходов, расходов и показателей эффективности по годам
        за 7-летний период.
      </p>
      <p>
        <a href="#investment" className="anchor-link">
          <strong>2. Расчет вложений для заданной площади</strong>
        </a>
        <br />
        Детализированная структура вложений по статьям затрат.
      </p>
      <p>
        <a href="#cashFlowSection" className="anchor-link">
          <strong>3. Прогноз движения денежных средств</strong>
        </a>
        <br />
        Детальный анализ возможных денежных потоков. В отличие от отчета о
        планируемых финансовых результатах, показывает возможные фактические
        движения средств («живые» деньги).
      </p>
      <p>
        <a href="#lastElem" className="anchor-link">
          <strong>4. Расчет продаж карт</strong>
        </a>
        <br />
        Пример формирования статьи «Поступления по картам» в отчете о прогнозе
        движении денежных средств.
      </p>

      <div className="out-area disclamer">
        ВНИМАНИЕ: Данный калькулятор является аналитическим инструментом для
        предварительного планирования и оценки гипотетических показателей.
        Представленные расчеты носят исключительно информационно-справочный
        характер и НЕ ЯВЛЯЮТСЯ гарантией будущих доходов или коммерческим
        предложением (офертой). Фактические финансовые результаты деятельности
        фитнес-клуба зависят от множества внешних и внутренних факторов
        (экономическая ситуация в регионе, действия конкурентов, эффективность
        управления Заказчика, изменения в законодательстве и др.), которые ООО
        МДК-Фитнес не контролирует и не может предсказать.
      </div>
    </div>
  );
};

export default TextBlock;
